import { render } from "./XmlPositionDataView.vue?vue&type=template&id=0639dbdb&scoped=true&ts=true"
import script from "./XmlPositionDataView.vue?vue&type=script&lang=ts"
export * from "./XmlPositionDataView.vue?vue&type=script&lang=ts"

import "./XmlPositionDataView.vue?vue&type=style&index=0&id=0639dbdb&scoped=true&lang=css"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0639dbdb"]])

export default __exports__